/**
 * @file tag-select.component.tsx
 * @description Form-control обертка для работы с UI TagSelect компонентом в react-hook-form с поддержкой выбора тегов
 * @author AI-Generated | Human-Reviewed
 * @created 2025-09-03
 * @updated 2025-09-09
 * @dependencies ['react', 'react-hook-form', '@components/ui/data/tag-select', '@src/types']
 * @related-files ['@components/ui/data/tag-select/tag-select.component.tsx']
 */

import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import { TagSelect as UITagSelect } from '@components/ui/data/tag-select';
import { ComponentProps } from 'react';
import { TBaseObjectDto } from '@src/types';

/**
 * Тип значения для поля тегов в форме
 */
interface ITagFieldValue {
    /** Массив выбранных тегов */
    value?: TBaseObjectDto[];
    /** Тип тега для внутренней обработки */
    $type?: string;
}

/**
 * Props для компонента TagSelect с интеграцией react-hook-form
 */
interface ITagSelectProps<TFieldValues extends FieldValues = FieldValues> 
    extends Omit<ComponentProps<typeof UITagSelect>, 'onChange' | 'value' | 'type'> {
    /** Control объект из react-hook-form для управления формой */
    control: Control<TFieldValues>;
    /** Имя поля в форме (путь к значению) */
    name: Path<TFieldValues>;
    /** Плейсхолдер для поля выбора */
    placeholder?: string;
    /** Заблокировано ли поле */
    isDisabled?: boolean;
    /** Обязательное ли поле */
    isRequired?: boolean;
    /** CSS класс для стилизации */
    className?: string;
}

export const TagSelect = <TFieldValues extends FieldValues = FieldValues>({ 
    control, 
    name, 
    ...props 
}: ITagSelectProps<TFieldValues>) => {
    return (
        <Controller
            name={name}
            control={control}
            render={({ field }) => {
                const fieldValue = field.value as ITagFieldValue | undefined;
                return (
                    <UITagSelect
                        {...props}
                        value={fieldValue?.value}
                        type={fieldValue?.$type || ''}
                        onChange={(newValue: TBaseObjectDto[]) => 
                            field.onChange({ ...fieldValue, value: newValue })
                        }
                    />
                );
            }}
        />
    );
};
